// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2SAhx","serviceBox":"maWyK","topic":"_3wZJO","free":"_2hl5D"};